import type { PropertyCardAddress } from '@federa/types/properties';

export function addressNeedsParsing(addressData: Pick<PropertyCardAddress, 'city' | 'state'>): boolean {
	const { city, state } = addressData;
	// Parse if no city/state OR if they contain commas (concatenated data)
	return !city || !state || city.includes(',') || state.includes(',');
}
